/* ---------------------------------------------------------------------------
   Ambient decoration for the Aqua Gel skin: drifting bubbles and the mascot.

   Both are purely decorative and are marked aria-hidden — a screen reader
   announcing "bubble bubble bubble" before the room code would be worse than
   useless. Neither accepts pointer events.
   --------------------------------------------------------------------------- */

/** Fixed sizes/positions rather than random, so the drift reads as composed. */
const BUBBLES = [
  { left: "12%", size: 46, dur: 11, delay: 0, from: -40 },
  { left: "62%", size: 74, dur: 15, delay: 2, from: -60 },
  { left: "82%", size: 30, dur: 9, delay: 4, from: -30 },
  { left: "34%", size: 58, dur: 13, delay: 6, from: -80 },
] as const;

export function Bubbles() {
  return (
    <div className="bd-bubbles" aria-hidden="true">
      {BUBBLES.map((b, i) => (
        <span
          key={i}
          className="bd-bubble"
          style={{
            left: b.left,
            bottom: `${b.from}px`,
            width: `${b.size}px`,
            height: `${b.size}px`,
            animationDuration: `${b.dur}s`,
            animationDelay: `${b.delay}s`,
          }}
        />
      ))}
    </div>
  );
}

/**
 * The mascot — a gel blob built entirely from CSS, no image request.
 *
 * `mood` drives the mouth so the same character can react to the phase:
 * idle in the lobby, wide open while a take is being recorded, flat when a
 * round has gone badly.
 */
export function Mascot({
  mood = "idle",
  size = 92,
}: {
  mood?: "idle" | "hyped" | "flat";
  size?: number;
}) {
  return (
    <div
      className={`bd-mascot bd-mascot-${mood}`}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      <span className="bd-mascot-body" />
      <span className="bd-mascot-shine" />
      <span className="bd-mascot-eye bd-mascot-eye-l">
        <i />
      </span>
      <span className="bd-mascot-eye bd-mascot-eye-r">
        <i />
      </span>
      <span className="bd-mascot-mouth" />
    </div>
  );
}
